import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CounselorsListView from './Counselors';

const CounselorsView = () => (
  <Routes>
    <Route path="list/*" element={<CounselorsListView />} />
    <Route index element={<Navigate to="list" replace />} />
  </Routes>
);

export default CounselorsView;
